module.exports = __webpack_public_path__ + "img/album18_12.8b5b895e.jpg";